import { t } from '../../../i18n';

function getSyntaxDetailKey(message) {
  const value = String(message || '');
  if (/No importable content/i.test(value)) return 'empty';
  if (/Incomplete flashcard|question and answer/i.test(value)) return 'incompleteCard';
  if (/both @Q: and @A:/i.test(value)) return 'qaRequired';
  if (/reading cards need a title/i.test(value)) return 'readingTitle';
  if (/reading cards need @Story|at least one practice segment/i.test(value)) return 'readingPractice';
  if (/continuation lines/i.test(value)) return 'continuation';
  if (/needs text/i.test(value)) return 'tagNeedsText';
  if (/legacy format|no longer supported/i.test(value)) return 'legacyTag';
  if (/Unsupported/i.test(value)) return 'unsupportedTag';
  if (/must use @ tags|Tagged format lines/i.test(value)) return 'taggedLine';
  if (/cannot mix/i.test(value)) return 'mixedCard';
  return 'generic';
}

export function formatComposerError(error, language) {
  if (!error) return '';
  if (error.reason === 'invalidSyntax') {
    return t(`noteComposer.errors.syntax.${getSyntaxDetailKey(error.originalMessage)}`, language);
  }
  return t(`noteComposer.errors.${error.reason}`, language, {
    count: error.count ?? '',
    expected: error.expectedType ?? '',
    actual: error.actualType ?? '',
    current: error.current ?? '',
    added: error.added ?? '',
    max: error.max ?? '',
    details: error.originalMessage || '',
  });
}

